module.exports = __webpack_public_path__ + "static/media/Comfortaa-Bold.8691f8d1.woff2";